<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-alert
            v-model="alert"
            type="error"
            close-text="Close"
            dismissible
          >
          {{ errorMessage }}
          </v-alert>
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Login</v-toolbar-title>
            </v-toolbar>
            <v-form @submit.prevent="onLogIn" v-show="!showCaptcha" v-model="valid" ref="loginForm">
              <v-card-text>
                <v-text-field
                  label="Login"
                  name="username"
                  id="username"
                  v-model="username"
                  prepend-icon="mdi-account"
                  type="text"
                  :rules="[rules.required, rules.email]"
                ></v-text-field>
                <v-text-field
                  id="password"
                  label="Password"
                  name="password"
                  v-model="password"
                  prepend-icon="mdi-lock"
                  type="password"
                  :rules="[rules.required]"
                ></v-text-field>
                
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn type="submit" color="primary" 
                :loading="loading"
                :disabled="loading"
                >Login</v-btn>
              </v-card-actions>
            </v-form>
                <!-- </v-text-field><vue-recaptcha sitekey="6Lc5P7EUAAAAAMljM3BwrnpM47K-hiRjeH2C8BT_"  :loadRecaptchaScript="true"><button>Click me</button></vue-recaptcha> -->
                <vue-recaptcha
                  ref="ecaptcha"
                  @verify="onVerify"
                  @expired="onExpired"
                  :sitekey="sitekey"
                  :loadRecaptchaScript="true"
                  v-if="showCaptcha" class="recaptcha text-center">
                </vue-recaptcha>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
export default {
  props: {
    source: String
  },
  data: () => ({
    username: "",
    password: "",
    alert: false,
    sitekey: '6LcSQLEUAAAAACgW6Rbx5nuiPSsIrWBh2syUk_u0',//'6Lc5P7EUAAAAAMljM3BwrnpM47K-hiRjeH2C8BT_'
    reCaptchaVerify: '',
    valid: false,
    rules: {
      required: value => !!value || 'Required.',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      },
    }
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    },
    errorMessage() {
      return this.$store.getters.loginError
    },
    loading() {
      return this.$store.getters.loggingIn
    },
    showCaptcha() {
      console.log(this.$store.getters.loginError);
      if (this.$store.getters.loginError) {
        return  this.$store.getters.loginError.code == "auth/too-many-requests"
      }
      return false;
    }
  },
  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/');
      }
    },
    errorMessage(value) {
      if (value && value.message.length > 0)
      {
        this.alert = true;
      } else {
        this.alert = false;
      }
    },
    alert(value) {
      if (!value) {
        this.$store.commit('clearLoginError');
      }
    },
    loading(value) {
      //console.log(`${value}`);
    },
    showCaptcha(value) {
      console.log(`CAPTCHA: ${value}`);
    }
  },
  methods: {
    onLogIn() {
      this.$refs.loginForm.validate();
      if (this.valid)
        this.$store.dispatch('signIn', { username: this.username, password: this.password, reCaptcha: this.reCaptchaVeriry});
    },
    onVerify: function (response) {
      console.log('Verify: ' + response)
      this.reCaptchaVeriry = response;
      this.$store.commit('clearLoginError'); // Reset reCaptcha
    },
    onExpired: function () {
      console.log('Expired')
    },
    resetRecaptcha () {
      this.$refs.recaptcha.reset() // Direct call reset method
    },
  },
  
  mounted() {
  },
  components: {
    'vue-recaptcha': VueRecaptcha
  }
};
</script>
